import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseFormInputField from '../../../../../shared/components/base-input-form-field/base-form-input-field';
import { ExceptedAppsReleaseFormProps } from '../types/excepted-apps-release-form-props.type';

export const VersionNameInput: FunctionComponent<
  ExceptedAppsReleaseFormProps
> = (props: PropsWithChildren<ExceptedAppsReleaseFormProps>) => {
  const { values, errors, touched, handleChange, handleBlur } = props;

  return (
    <FormControl>
      <BaseFormInputField
        id="version-name"
        label="Version Name"
        name="versionName"
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!errors.versionName && touched.versionName}
        helperText={
          !!errors.versionName && touched.versionName && errors.versionName
        }
        value={values?.versionName ?? ''}
        InputLabelProps={{ required: true }}
      />
    </FormControl>
  );
};
